export const PUBLIC_CHANNEL='public-auction'
export const AUCTION_UPDATED='auction.updated'
export const PRIVATE_USER_ID='private-user.USERID'
export const TERMS_CONDITIONS_UPDATE='terms-and-conditions.updated'
export const BUYER_APP_ACCEPTED='buyer-application.accepted'
export const BUYER_APP_REJECTED='buyer-application.rejected'
export const BUYER_STATUS_UPDATED='buyer-status.updated'